export interface IIepType {
  id: string;
  description: string;
  title?: string;
}

export class IepTypeAdd {
  id: number;
  studentSK: string;
  referralSK: string;
  iepFormSK: string;
  iepMeetingDate: Date;
  latestIepMeetingDate: Date;
  iepType: string;
  projectedAnnRevDate: Date;
  meetsOtherDef: boolean;
  projectedNxtManThreeYrRevalDate: Date;
  iepAmendment: boolean;
  reconveneIEPMeeting: boolean;
  disability: number;
  specialEdServ: boolean;
  lackInstructMath: boolean;
  lackOutstructReading: boolean;
  limitedEnglishProf: boolean;
  otherImpairment: number;
  otherImpairementDesc: string;
  disabilityClass: boolean;
  requiresSpecEd: boolean;
  medicalCondition: boolean;
  physicalLimit: boolean;
  learning: boolean;
  behavior: boolean;
  participation: boolean;
  reqMedicalCare: boolean;
  reqHealthCare: boolean;
  lastModuser: string;
  lastModTs: Date;
  isLocked: boolean;
  isSubmit: boolean;
  typeOfMeeting: number;
  meetingsk: string;
  inEligibilitySk: string;
  declassficationSk: string;
  isAnnual: boolean;
  referenceIEPFormsk: string;
  previousIEP: string;
  iepStatus: number;
  iepFormSk: string;
}

export interface Goal {
  annualGoalSeq?: number;
  criteria?: string;
  method?: string;
  frequency?: number;
  freqInterval?: number;
  goalNarrative?: string;
  freqIntervalOther?: string;
  operationType?: number;
  otherFrequency?: string;
  objective?: [];
  objectives?: [];
}

export class IepMeasurable {
  iepFormSK?: string;
  isLocked?: boolean;
  isSubmit?: boolean;
  actionType?: number;
  operationType?: number;
  studentSK?: string;
  iepFormSk?: string;
  goals?: Goal[];

  constructor() {
    this.goals = [{ annualGoalSeq: null }];
    this.goals = [{ criteria: 'Dummy' }];
    this.goals = [{ method: 'Dummy' }];
    this.goals = [{ frequency: 1 }];
    this.goals = [{ freqInterval: 5 }];
    this.goals = [{ goalNarrative: 'Dummy' }];
    this.goals = [{ freqIntervalOther: null }];
    this.goals = [{ operationType: 1 }];
    this.goals = [{ otherFrequency: null }];
    this.goals = [{ objective: [] }];
  }
}
